module.exports = __webpack_public_path__ + "img/arrow-circle-up-right.8f20473a.svg";